import { Box, Button, IconButton, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import Image from "next/image";
import { formatToNaira, pxToRem } from "@/util";
import { AppColors } from "@/assets/colors";
type props = {
  isBack: boolean;
  isShare: boolean;
  amount: number;
  isAmount: boolean;
  handleBack: () => void;
  name: string;
  location: string;
};
export default function ListingsHead({
  isBack = true,
  isShare = true,
  amount,
  isAmount = true,
  handleBack,
  name = "",
  location = "",
}: Partial<props>) {
  const { classes } = styles();

  return (
    <Box className={classes.alignment}>
      {isBack && (
        <Box>
          <Button
            startIcon={<NavigateBeforeIcon />}
            onClick={() => handleBack && handleBack()}
          >
            {" "}
            Back to Search
          </Button>
        </Box>
      )}
      <Box className={classes.mainAlignment}>
        <Box className={`${classes.head} `}>
          <Typography className={classes.name}>
            {`${name || "Property Name"}`}
          </Typography>
          <Box className={`${classes.loc}`}>
            <Image
              src={"/images/property/location.svg"}
              alt="location"
              width={24}
              height={24}
            />
            <Typography className={classes.location}>{`${
              location || "Location"
            }`}</Typography>
          </Box>
        </Box>
        <Box>
          {isShare ? (
            <Box>
              <IconButton>
                <Image
                  src={"/images/property/share.svg"}
                  alt="share"
                  width={24}
                  height={24}
                />
              </IconButton>
              <IconButton>
                <Image
                  src={"/images/property/print.svg"}
                  alt="print"
                  width={24}
                  height={24}
                />
              </IconButton>
            </Box>
          ) : (
            isAmount && (
              <Box>
                <Typography className={classes.amount}>
                  {formatToNaira(amount || 0) || 0}
                </Typography>
              </Box>
            )
          )}
        </Box>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  debug: {
    border: "1px solid red",
  },
  head: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  alignment: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
    },
  },
  mainAlignment: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: theme.spacing(2),
    },
  },
  amount: {
    fontWeight: 600,
    fontSize: pxToRem(38),
    color: AppColors.primary["300"],
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(25),
    },
  },
  name: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(30),
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(25),
      paddingLeft: pxToRem(5),
    },
  },
  loc: {
    display: "flex",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {},
  },
  location: {
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(17),
    },
  },
  locTxt: {
    fontWeight: 500,
    fontSize: pxToRem(16),
  },
}));
